import {Injectable} from '@angular/core';
const StringMask = require('string-mask');

@Injectable()
export class TelephoneService {
  private mask8D: any;
  private mask9D: any;

  constructor() {
    this.mask8D = new StringMask('(+00) (00) 0000-0000');
    this.mask9D = new StringMask('(00) 00000-0000');
  }

  public applyValueChanges(element: HTMLInputElement) {
    element.value = this.applyMask(element);
  }

  public clearValue(val: string) {
    return val.toString().replace(/[^0-9]/g, '').slice(0, 13);
  }

  public applyMask(element: HTMLInputElement) {
    const val: string = element.value;
    const lastCharPosition: number = val.length - 1;
    if (val.charAt(lastCharPosition) === '-') {
      element.selectionStart = element.selectionEnd = val.length - 1;
    }
    if (val.charAt(lastCharPosition) === ' ') {
      element.selectionStart = element.selectionEnd = val.length - 2;
    }
    const clearedValue = this.clearValue(val);
    if (clearedValue.length < 11) {
      return this.mask8D.apply(clearedValue);
    } else {
      return this.mask9D.apply(clearedValue);
    }
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shared/telephone-mask/telephone.service.ts